/**
 * @data 2025.10.23
 * @author hudie
 * @description 设置字体 民族文（主题设置）和偏好字体（偏好设置-字体设置）逻辑都统一在这里处理
 * 有区别
 * 民族文优先级高于偏好字体
 * 1. 【取值】 民族文-[nationalTheme-code, fontUrl-url]； 偏好字体[fontFamily, fontSize, customSetting]
 * 1. 【作用范围】 民族文 [编辑器、稿件列表、稿件详情、快速浏览、编辑器标题引题副题、编辑器稿签、图说编辑框]
 * 2. 【设置】民族文需要code和url；偏好字体有[fontFamily, fontSize, customSetting]customSetting为开关，开启才有效
 */
import './fontsize.scss'
import fontSetting from 'common-mediax/src/common/preferenceSetting/common.js'

/**
 * @name setFontConfig
 * @description 设置字体配置
 * @param {object} config 字体设置
 * @param {string} config.nationalTheme 民族文字体设置的字体包主题
 * @param {string} config.fontUrl 民族文字体设置的字体包在线地址
 * @param {string} config.fontFamily 字体设置的字体-family
 * @param {string} config.fontSize 字体设置的字体-size
 * @param {boolean} config.customSetting 字体设置的自定义字体开关
 */
const setFontConfig = fontSetting.setFontConfig

/**
 * @name getFontConfig
 * @description 获取字体配置
 * @param {string} type 类型 民族文或偏好字体 ['national'-民族文 | 'preference'-偏好字体]
 * @returns {object} 字体配置
 * @property {string} type 类型 民族文或偏好字体 ['national'-民族文 | 'preference'-偏好字体]
 */
const getFontConfig = (type) => {
  // 如果获取特定的字体配置 则直接返回
  if (type) {
    return fontSetting.getFontConfig(type)
  }
  // 如果没有指定类型 则优先返回民族文配置 并且Object中的type可以区分其类别
  let nationalFont = fontSetting.getFontConfig('national')
  if (nationalFont) {
    return nationalFont
  } else {
    let preferenceFont = fontSetting.getFontConfig('preference')
    return preferenceFont
  }
}

/**
 * @name setFontStyleToEle
 * @description 将对应字体的字体包 设置到元素，如果有主题特殊布局的也需要单独处理
 * @param {object} options 字体设置
 * @param {Array[String]} options.selector 选择器 和el二选一 传入选择器 传入Array 或者 String 【民族文&偏好字体】用
 * @param {Array[String]} options.nationalSelector 同selector 仅【民族文】用 用于单独只针对于民族文使用而偏好字体不适用的情况
 * @param {Array[String]} options.preferenceSelector 同selector 仅【偏好字体】用 用于单独只针对于偏好字体使用而民族文不适用的情况
 * @param {dom} options.el 节点 和selector二选一 编辑器必须传入el
 * @param {string} options.fontFamily 字体设置的字体-family
 * @param {string[]} options.types 设置的字体样式类型 传入Array 可以传空数组 也可以传入['fontSize', 'fontFamily']中的任意值。比如：['fontSize'] 或者 ['fontFamily']，['fontSize']表示只设置字体大小，缺省传入['fontSize', 'fontFamily']
 * @param {string} options.elType 类型 编辑器传入'ueditor'
 * @param {*object} options.defaultConfig 仅【偏好字体】用，默认配置 传入对象 对象包含fontSize和fontFamily
 * @param {string} options.elseCss 其他css样式 传入对象 对象包含fontSize和fontFamily
 * @param {string} insertStyleType 插入样式类型 append | cover
 * @returns {string} 最终插入的样式文本
 */
const setFontStyleToEle = (options, insertStyleType) => {
  let config = getFontConfig()
  /**
   * @param config.type 类型 民族文或偏好字体 ['national'-民族文 | 'preference'-偏好字体]
   * 【民族文】设置fontFamily&其他布局样式
   * 【偏好字体】设置fontFamily&fontSize
   */
  if (typeof options !== 'object') {
    console.log('setFontStyleToEle -- options 必传')
    return
  }
  if (config.type === 'national') {
    setFontFace(config)
    if (config.fontFamily) {
      setFontClass(config.fontFamily) //给body一个整体的class 去控制布局
    }
  } else if (
    config.type === 'preference' ||
    options.defaultConfig?.fontFamily ||
    options.defaultConfig?.fontSize
  ) {
    // 兼容一下 参数管理-设置编辑器缺省字体字号
    if (!config && options.defaultConfig) {
      config = options.defaultConfig
    }
  }
  return fontSetting.setCustomFontStyle(options, config, insertStyleType)
}

/**
 * @name setFontClass
 * @description 通过给body一个class 去控制民族文主题的布局
 * @param {string} code 民族文的code 唯一标识
 */
const setFontClass = (code) => {
  if (code) fontSetting.setFontClass(code)
}

/**
 * @name setFontFace
 * @description 设置在线字体包 将字体包设置到id为[fontFaceSettingStyle]的style标签
 * @param {object} fontStyle 字体设置
 * @param {string} fontStyle.fontUrl 字体包在线地址
 * @param {string} fontStyle.fontFamily 字体-family
 */
const setFontFace = fontSetting.setFontFace

export default {
  setConfig: setFontConfig, // 设置字体配置
  getConfig: getFontConfig, // 获取字体配置
  setFontStyleToEle, // 将对应字体的字体包 设置到元素，如果有主题特殊布局的也需要单独处理
  setFontClass // 通过给body一个class 去控制民族文主题的布局
}
